import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import useLinkProps from '../../../../../hooks/use-link-props';
import BackgroundLink from '../../../../ui/links/background';
import RelatedProduct from '../../../../ui/v2/products/related';
import { Carousel, CarouselBullets, CarouselContent, CarouselItem } from '../../../../ui/carousel-v2';

const LastEntries: FunctionComponent<{
  products: Array<TProductListItem>;
  vehicle?: TCarInfo;
}> = ({ products, vehicle }) => {
  const { t } = useTranslation();
  const getLink = useLinkProps();

  return (
    <section className={cx('bg-neutral-10', 'pt-12', 'pb-[42px]')}>
      <span
        className={cx(
          'container mx-auto',
          'block',
          'font-bold',
          'max-lg:px-8',
          'text-[22px]',
          'lg:text-[32px]',
          '',
          'text-center',
          'mb-6'
        )}
      >
        {t('vehicle:last-entries', {
          vehicle: `${vehicle?.brand?.name || ''} ${vehicle?.model?.name || ''}`,
        })}
      </span>

      <div className="container m-auto">
        <Carousel
          opts={{
            align: 'center',
          }}
          viewportBasedSlidesToScroll={{
            desktop: 4,
            mobile: 1,
          }}
        >
          <CarouselContent className="pb-2 lg:-ml-6">
            {products.map((product, index) => {
              return <CarouselItem
                key={product.id.toString()}
                className="pl-0 basis-4/5 lg:basis-1/4 lg:pl-6 lg:grid lg:grid-cols-1 lg:gap-6 max-lg:h-fit"
              >
                <BackgroundLink
                  {...getLink('product', {
                    category: product.category_slug,
                    subCategory: product.slug,
                  })}
                  onClick={() => {
                    window?.dataLayer.push({
                      event: 'eec.impressionClick',
                      ecommerce: {
                        currencyCode: 'EUR', // currency code
                        click: {
                          actionField: {
                            list: 'Last Parts in Stock', // List name where the impression click occured
                          },

                          products: [
                            {
                              id: product.sku, // SKU of the product
                              name: product.part_en, // name of the product.
                              brand: product.car_brand, // car brand of the part
                              category: product.category_en_old, // Product category(ies) - each "/" is a category level (max 5 levels)
                              price: product.pricing?.price_product
                                ? Number(product.pricing.price_product).toFixed(2)
                                : null, // price of the part without shipping, tax and currency
                              position: index, // the position of the item in the list
                              dimension2: product.reference, // reference of the product
                              dimension3: product.car_model, // car model of the part
                              dimension4: product?.car_version, // car version of the part
                            },
                          ],
                        },
                      },
                    });

                    // GA4
                    window?.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                    window?.dataLayer.push({
                      event: 'select_item',
                      ecommerce: {
                        currency: 'EUR',
                        items: [
                          {
                            item_name: product.part_en,
                            item_id: product.sku,
                            price: product.pricing?.price_product
                              ? Number(product.pricing.price_product).toFixed(2)
                              : null,
                            item_brand: product.car_brand,
                            item_category: product.category_en,
                            item_category2: product.part_en,
                            item_list_name: 'Last Parts in Stock',
                            item_list_id: 'last-parts-in-stock',
                            index: index,
                            quantity: '1',
                          },
                        ],
                      },
                    });
                  }}
                >
                  <RelatedProduct
                    product={product}
                    info={{
                      category: product.category_en,
                      subCategory: product.part,
                    }}
                  />
                </BackgroundLink>
              </CarouselItem>
            })}
          </CarouselContent>
          <CarouselBullets className="!mt-6 max-lg:hidden" />
        </Carousel>
      </div>
    </section >
  );
};

export default LastEntries;
